import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner if no consent yet ✅
    const consent = localStorage.getItem(
      'sb_cookie_consent');
    if (!consent) {
      // Small delay so page loads first ✅
      setTimeout(() => setVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(
      'sb_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(
      'sb_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0
                    z-50 p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto
                      bg-gray-900 border
                      border-gray-700
                      rounded-2xl p-5
                      shadow-2xl
                      flex flex-col sm:flex-row
                      items-start sm:items-center
                      gap-4">

        {/* Text */}
        <div className="flex-1">
          <p className="text-gray-300 text-sm
                        leading-relaxed">
            🍪 We use essential cookies for
            authentication and to improve your
            experience. By continuing, you agree
            to our{' '}
            <Link to="/privacy"
                  className="text-blue-400
                             hover:text-blue-300
                             underline">
              Privacy Policy
            </Link>
            {' '}and{' '}
            <Link to="/terms"
                  className="text-blue-400
                             hover:text-blue-300
                             underline">
              Terms of Service
            </Link>
            .
          </p>
        </div>

        {/* Buttons */}
        <div className="flex items-center
                        gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="text-gray-500
                       hover:text-gray-300
                       text-sm transition-colors
                       px-3 py-2">
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="bg-blue-600
                       hover:bg-blue-500
                       text-white text-sm
                       font-semibold px-5 py-2
                       rounded-xl
                       transition-colors">
            Accept All
          </button>
          <button
            onClick={handleDecline}
            className="text-gray-600
                       hover:text-gray-400
                       transition-colors p-1">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;